import { GetStaticProps } from "next";
import getTranslations from "../lib/getTranslations";
import PrivacyPolicy from "@whoppah/components/privacy-policy/PrivacyPolicy";

const PrivacyPolicyPage = () => {
  return <PrivacyPolicy />;
};

PrivacyPolicyPage.getLayout = (page: JSX.Element) => page;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await getTranslations(locale, ["privacy-policy"])),
    },
  };
};

export default PrivacyPolicyPage;
